import Breadcrumb from './Breadcrumb.vue'
import Callout from './Callout.vue'
import Footer from './Footer.vue'
import Header from './Header/Header.vue'
import ResponsiveNav from './Header/ResponsiveNav.vue'
import PageTitle from './PageTitle.vue'

export {
  Breadcrumb,
  Callout,
  Footer,
  Header,
  PageTitle,
  ResponsiveNav
}



// WEBPACK FOOTER //
// ./src/components/index.js